<template>
  <div>
    <div>
      <h3>{{ this.skillName }}</h3>
    </div>
    <table class="table" width="100%">
        <thead>
            <tr>
                <th>Persona</th>
                <th>Livello</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="element in list">
                <td>{{ element.fullName }}</td>
                <td>{{ element.level }}</td>
            </tr>
        </tbody>
    </table>
  </div>
</template>

<script>

  export default {
      data () {
          return {
              list : [],
              skillName : "",
          }
      },
      mounted() {
          this.changeUrl(this.url);
      },
      methods:{
          changeUrl(url){

            axios.get(url)
                .then((response) => {
                  this.list = response.data.people;
                  this.skillName = response.data.skillName;
                });
          },
      },
      props: {
          url: {
              type: String,
              required: true
          }
      }

  }
</script>